import { Col, Spinner } from 'react-bootstrap';
import { CSSProperties } from 'react';
const defaultMessage = 'Loading...';

export default function MiniSpinner({
  message = defaultMessage,
  overlay = false,
}: { message?: string; overlay?: boolean } = {}) {
  const overlayStyle: CSSProperties = { position: 'absolute', top: 5, right: 10, zIndex: 1000 };
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      id="loadingContainer"
      style={overlay ? overlayStyle : undefined}
    >
      <Spinner className="spinner-border" role="status" />
      <p id="statusMessage" className="mx-1 mt-3 text-muted" style={{ fontSize: '0.9rem' }}>
        {message}
      </p>
    </div>
  );
}
